import React from 'react'
import {
  AverageBeatsPerMinute,
  MaximumBeatsPerMinute,
  MinimumBeatsPerMinute,
  AvgUnit,
  AvgValue,
  MaxValue,
  MinValue,
  Content,
  Range,
  Label
} from './styles'
import { BehaviorCard } from '~/components/behaviors/BehaviorCard'
import { message } from '~/services'
import { capitalize, transformDate } from '~/utils'
import { IBehavior } from '~/interfaces'

interface IProps {
  behavior: IBehavior | undefined
}

export const HeartRate = ({ behavior }: IProps): JSX.Element => {
  if (!behavior) return <></>
  if (behavior.type !== 'Avaliação Cardíaca') return <></>

  const { type, endDate, properties } = behavior

  // TODO: tratar a renderização de campos sem valores
  const datetimeLastUpdate = transformDate({ date: endDate, withHourAndMinute: false, dateFormat: 'dd/MM HH:mm' })
  const averageBeatsPerMinute = properties.find(p => p.type === 'Frequência Cardíaca Média')
  const maximumBeatsPerMinute = properties.find(p => p.type === 'Frequência Cardíaca Máxima')
  const minimumBeatsPerMinute = properties.find(p => p.type === 'Frequência Cardíaca Mínima')

  return (
    <BehaviorCard title={type} iconName="behaviorHeartRate" time={datetimeLastUpdate}>
      <Content>
        <AverageBeatsPerMinute>
          <AvgValue>{averageBeatsPerMinute?.value}</AvgValue>
          <AvgUnit>{capitalize(averageBeatsPerMinute?.unit ?? '')}</AvgUnit>
        </AverageBeatsPerMinute>

        <Range>
          <MinimumBeatsPerMinute>
            <MinValue>{minimumBeatsPerMinute?.value}</MinValue>
            <Label>{message('behaviors.heartRateMinimum')}</Label>
          </MinimumBeatsPerMinute>
          <MaximumBeatsPerMinute>
            <MaxValue>{maximumBeatsPerMinute?.value}</MaxValue>
            <Label>{message('behaviors.heartRateMaximum')}</Label>
          </MaximumBeatsPerMinute>
        </Range>
      </Content>
    </BehaviorCard>
  )
}
